import { centsToDollarsDisplay } from "../../displayFormatters"
import StatisticCards from "../../common/StatisticCards"
import { InvoiceTotals } from "./workareaTotalsModel"

type Props = {
  invoiceTotals: InvoiceTotals
}

const InvoiceTotalStatistics = ({ invoiceTotals }: Props) => {
  return <StatisticCards title="Invoice Totals" items={[
    { title: 'Not Invoiced', value: centsToDollarsDisplay(invoiceTotals.notInvoiced) ?? '' },
    { title: 'Outstanding', value: centsToDollarsDisplay(invoiceTotals.outstanding) ?? '' },
    { title: 'Paid', value: centsToDollarsDisplay(invoiceTotals.paid) ?? '' },
  ]} />
}

export default InvoiceTotalStatistics
